import { emailInputValidationSchema } from "../../../../components/AuthForm/components/EmailInput/validation.js";
import { passwordInputValidationSchema } from "../../../../components/AuthForm/components/PasswordInput/validation.js";

export const loginValidationSchema = emailInputValidationSchema.concat(passwordInputValidationSchema);
